import React, { FC } from 'react';
import { Box, Text } from '@endpoint/blockparty';
import { DataBlock, Label } from 'components/DataBlock';
import { useBankDetailsByMarketId } from 'hooks/useBankDetailsByMarketId';

import { WireTransferProps } from '..';

/* ======================================= */

export const WireTransferInstructionsUS: FC<WireTransferProps> = ({
  accountNumber,
  isPinnedItem,
  paymentAmount,
  payableName,
  routingNumber,
  streetAddress,
  suite,
  cityStateZip,
  layoutType = 'stack',
  marketId,
  isUnityTransaction,
}) => {
  const bankAddress = useBankDetailsByMarketId(marketId, isUnityTransaction);

  return (
    <DataBlock layoutType={layoutType}>
      <Box>
        <Label>Amount</Label>
        <Text as="p" data-test-id="wire-us-amount">
          {paymentAmount}
        </Text>
      </Box>
      <Box>
        <Label>Payable to</Label>
        <Text as="p" data-test-id="wire-us-payable-name">
          {payableName}
        </Text>
      </Box>
      {!isPinnedItem && (
        <Box>
          <Label>Receiving Bank</Label>
          <Text as="p" data-test-id="wire-us-receiving-bank-name">
            {bankAddress.name}
          </Text>
          <Text as="p" data-test-id="wire-us-receiving-bank-address-line1">
            {bankAddress.addressLine1}
          </Text>
          <Text as="p" data-test-id="wire-us-receiving-bank-address-line2">
            {bankAddress.addressLine2}
          </Text>
        </Box>
      )}
      <Box>
        <Label>Account #</Label>
        <Text as="p" data-test-id="wire-us-account-number">
          {accountNumber}
        </Text>
      </Box>
      <Box>
        <Label>Routing #</Label>
        <Text as="p" data-test-id="wire-us-routing-number">
          {routingNumber}
        </Text>
      </Box>
      <Box>
        <Label>Credit Beneficiary</Label>
        <Text as="p" data-test-id="wire-ep-payable-name">
          {payableName}
        </Text>
        <Text as="p" data-test-id="wire-ep-street-address">
          {streetAddress}
        </Text>
        <Text as="p" data-test-id="wire-ep-suite">
          {suite}
        </Text>
        <Text as="p" data-test-id="wire-ep-city-state-zip">
          {cityStateZip}
        </Text>
      </Box>
    </DataBlock>
  );
};
